import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';

import { AuthService } from '../../shared/services/auth.service';

@Component({
  selector: 'app-verify-otp',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './verify-otp.component.html',
  styleUrl: './verify-otp.component.scss',
})
export class VerifyOtpComponent implements OnInit {
  private authService = inject(AuthService);
  private router = inject(Router);

  otp = '';
  email = '';
  loading = false;
  errorMessage = '';

  ngOnInit() {
    this.email = localStorage.getItem('verifyEmail') || '';
  }

  verifyOtp() {
    if (!this.otp || this.otp.length < 4) {
      this.errorMessage = 'Please enter the verification code.';
      return;
    }
    this.loading = true;
    this.errorMessage = '';

    this.authService.verifyOtp(this.email, this.otp).subscribe({
      next: () => {
        this.loading = false;
        const flow = localStorage.getItem('authFlow');
        if (flow === 'forgotPassword') {
          this.router.navigate(['/auth/update-password']);
        } else {
          this.router.navigate(['/auth/complete-profile']);
        }
      },
      error: (err: any) => {
        this.loading = false;
        this.errorMessage = err?.error?.message ?? 'Invalid or expired code. Please try again.';
      },
    });
  }

  resendOtp() {
    if (!this.email) return;
    this.errorMessage = '';
    const purpose =
      localStorage.getItem('authFlow') === 'forgotPassword' ? 'forgot-password' : 'register';
    this.authService.generateOtp(this.email, purpose).subscribe({
      next: (res) => {
        // Always HTTP 200, a rejected "no account found" case (shouldn't
        // normally happen here, since reaching this page already implies an
        // earlier successful check) is reported via success: false.
        if (!res.success) {
          this.errorMessage = res.message || 'Could not resend code.';
          return;
        }
        this.errorMessage = '';
        // Optionally show a success toast, for now just clear the input
        this.otp = '';
      },
      error: () => {
        this.errorMessage = 'Failed to resend code. Please try again.';
      },
    });
  }
}
